import type { ReactNode } from "react";
import { useFocusable } from "../../../modules/spatialNavigation";
import * as styles from "./styles.module.scss";

interface IProps {
  children: ReactNode;
  className?: string;
  onClick: () => void;
  focused?: boolean;
  focusKey?: string;
  onEnterPress?: () => void;
  onArrowPress?: (e) => void;
}

const IconButton = (props: IProps) => {
  const { focused, ref } = useFocusable({
    focusKey: props.focusKey,
    onEnterPress: (p, d) => (props.onEnterPress ? props.onEnterPress() : null),
    onArrowPress: (p, d) => {
      if (props.onArrowPress) {
        props.onArrowPress(p);
      }
      return true;
    },
  });

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      props.onClick();
    }
  };

  return (
    <button
      ref={ref}
      onKeyDown={onKeyDown}
      onClick={props.onClick}
      className={`${styles.button} ${props.className ?? ""} ${focused ? styles.focused : ""}`}
    >
      {props.children}
    </button>
  );
};

export default IconButton;
